
/**
 * waterLevel Chart Min And Max Data
 * 
 * @param wlDataList 현재 수위 목록
 * @param mwlDataList 수동 수위 목록
 * @param wrnstep1List 주의 수위 목록
 * @param wrnstep2List 경계 수위 목록
 * @param wrnstep3List 심각 수위 목록
 * @param arfDataList 우량 목록
 * @param secList 단면적 목록
 * @param gdt 해발표고
 * @returns 최소/최대값
 */
export function getWaterLevelMinMax(wlDataList, mwlDataList, wrnstep1List, wrnstep2List, wrnstep3List, arfDataList, secList, ySecList,gdt) {
	wlDataList = dataCheck(wlDataList);
	mwlDataList = dataCheck(mwlDataList);
	arfDataList = dataCheck(arfDataList);
	secList = dataCheck(secList);
	ySecList = dataCheck(ySecList);
	
	var params = [wrnstep1List, wrnstep2List, wrnstep3List]; 
    var filteredParams = params.filter(el => el !== null && !isNaN(el));
	
	var wlMin = Math.min(...wlDataList, ...mwlDataList, ...filteredParams, ...ySecList);
	var wlMax = Math.max(...wlDataList, ...mwlDataList, ...filteredParams, ...ySecList);
	
    /*var areaMin = Math.min(...ySecList);
    var areaMax = Math.max(...ySecList);*/
    
    var areaMin = wlMin + gdt;
    var areaMax = wlMax + gdt;
    
    /*var areaMinus = areaMax - areaMin;
    
    areaMin = areaMin+wlMin;
	areaMax = areaMax+wlMax;*/
	
	var tickX1 =[];
	var tickX2 =[];
    var nTick = 6;
    /*if(wlMax - wlMin < 0.07){
		 nTick = 1;
	}*/
	
	wlMax += 2;
    wlMin -= 2;
    
    areaMax += 2;
    areaMin -= 2;
	
	/*wlMax += areaMinus>=9 ? 5 : 3;
    wlMin -= 1; 
    
    areaMax -= areaMinus;
    areaMax += areaMinus>=9 ? 5 :3;
    areaMin -= 1;*/
		
	var avg1 = (wlMax-wlMin)/nTick;
	var avg2 = (areaMax-areaMin)/nTick;
	
	for(var i=0; i <= nTick; i++){
		tickX1.push(wlMin+avg1*i);
		tickX2.push(areaMin+avg2*i);
	}
    
    const arfMax = Math.max(...arfDataList);
    
	return {
		waterLevelMin : wlMin - 1,
		waterLevelMax : wlMax + 3,
		tickX1 : tickX1,
		tickX2 : tickX2,
		areaMin : areaMin,
		areaMax : areaMax,
		arfMax : arfMax*4
	}
}

/**
 * rainfall Chart Min And Max Data
 * 
 * @param obsdvcd 자동/수동 여부
 * @param rainfallList 현재 강수량 목록
 * @param mrainfallList 수동 강수량 목록
 * @param sumRainfallList 누적 강수량 목록
 * @returns 최소/최대값
 */
export function getRainfallMinMax(obsdvcd, rainfallList, mrainfallList, sumRainfallList, sumMrainfallList){
	rainfallList = dataCheck(rainfallList);
	mrainfallList = dataCheck(mrainfallList);
	sumRainfallList = dataCheck(sumRainfallList);
	sumMrainfallList = dataCheck(sumMrainfallList);
	
	let rainfallMin, rainfallMax, sumRainfallMin, sumRainfallMax;
	
	if (obsdvcd === "1101") {
		// 자동
		rainfallMin = Math.min(...rainfallList);
		rainfallMax = Math.max(...rainfallList);
		
		sumRainfallMin = Math.min(...sumRainfallList);
		sumRainfallMax = Math.max(...sumRainfallList);
	} else if (obsdvcd === "1102") {
		// 수동
		rainfallMin = Math.min( ...mrainfallList);
		rainfallMax = Math.max(...mrainfallList);
		
		sumRainfallMin = Math.min(...sumMrainfallList);
		sumRainfallMax = Math.max(...sumMrainfallList);
	} else if (obsdvcd === "1103") {
		// 자동, 수동
		rainfallMin = Math.min(...rainfallList, ...mrainfallList);
		rainfallMax = Math.max(...rainfallList, ...mrainfallList);
		
		sumRainfallMin = Math.min(...sumRainfallList);
		sumRainfallMax = Math.max(...sumRainfallList);
	}
	
	return {
		rainfallMin : rainfallMin,
		rainfallMax : rainfallMax + 5,
		sumRainfallMin : sumRainfallMin,
		sumRainfallMax : sumRainfallMax + 5
	}
}

// 데이터 필터링
function dataCheck(array){ 
	var filterArray = [];

	if (array == null) {
        return filterArray; // 빈 배열 반환
    }

    array.forEach(el => {
        if (el !== null && !isNaN(el)) {
            filterArray.push(el);
        }
    });
	
	return filterArray;
}